
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const handleSocialClick = (platform: string) => {
    const urls = {
      twitter: 'https://x.com/groupnichinan?s=21&t=yEM357mP8-B7NN0nwrJb6g',
      facebook: 'https://www.facebook.com/share/1FpGLhN61R/?mibextid=wwXIfr',
      instagram: 'https://www.instagram.com/nichinan.group?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==',
      dribbble: 'https://www.nichinan-group.com/'
    };
    
    window.open(urls[platform as keyof typeof urls], '_blank', 'noopener,noreferrer');
  };

  return (
    <footer className="bg-stone-800 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <div className="mb-6">
              <h3 className="text-xl font-bold mb-2">{t('footer.companyName')}</h3>
              <p className="text-stone-300 text-sm leading-relaxed">
                {t('footer.companyDescription')}
              </p>
            </div>
            <div className="flex space-x-3">
              <button 
                onClick={() => handleSocialClick('twitter')}
                className="w-8 h-8 bg-stone-700 rounded-md flex items-center justify-center hover:bg-stone-600 transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-fill text-sm"></i>
              </button>
              <button 
                onClick={() => handleSocialClick('facebook')}
                className="w-8 h-8 bg-stone-700 rounded-md flex items-center justify-center hover:bg-stone-600 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-sm"></i>
              </button>
              <button 
                onClick={() => handleSocialClick('instagram')}
                className="w-8 h-8 bg-stone-700 rounded-md flex items-center justify-center hover:bg-stone-600 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-fill text-sm"></i>
              </button>
              <button 
                onClick={() => handleSocialClick('dribbble')}
                className="w-8 h-8 bg-stone-700 rounded-md flex items-center justify-center hover:bg-stone-600 transition-colors cursor-pointer"
              >
                <i className="ri-home-fill text-sm"></i>
              </button>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold mb-3 text-stone-200">{t('footer.servicesTitle')}</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-stone-400 hover:text-stone-200 transition-colors cursor-pointer text-xs">{t('footer.service1')}</a></li>
              <li><a href="#" className="text-stone-400 hover:text-stone-200 transition-colors cursor-pointer text-xs">{t('footer.service2')}</a></li>
              <li><a href="#" className="text-stone-400 hover:text-stone-200 transition-colors cursor-pointer text-xs">{t('footer.service3')}</a></li>
              <li><a href="#" className="text-stone-400 hover:text-stone-200 transition-colors cursor-pointer text-xs">{t('footer.service4')}</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold mb-3 text-stone-200">{t('footer.companyInfoTitle')}</h3>
            <ul className="space-y-2">
              <li className="text-stone-400 text-xs">{t('footer.companyNameLabel')}</li>
              <li className="text-stone-400 text-xs">{t('footer.postalCode')}</li>
              <li className="text-stone-400 text-xs">{t('footer.address')}</li>
              <li className="text-stone-400 text-xs">{t('footer.tel')}</li>
              <li className="text-stone-400 text-xs">{t('footer.fax')}</li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-stone-700 mt-6 pt-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-stone-400 text-xs">
            {t('footer.copyright')}
          </p>
          <div className="flex items-center space-x-4 mt-3 md:mt-0">
            <a href="#" className="text-stone-400 hover:text-stone-200 text-xs transition-colors cursor-pointer">{t('footer.privacyPolicy')}</a>
            <a href="#" className="text-stone-400 hover:text-stone-200 text-xs transition-colors cursor-pointer">{t('footer.termsOfService')}</a>
            <a href="https://readdy.ai/?origin=logo" className="text-stone-400 hover:text-stone-200 text-xs transition-colors cursor-pointer">Website Builder</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
